import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/technologies/big-data/page.tsx");
